var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFocusAreaSpokenInteractionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Communication",
    clipPath: "url(#clip0_1433_23225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.0007 6.66634V18.333H8.61732L6.66732 20.283V6.66634H25.0007ZM26.6673 3.33301H5.00065C4.08398 3.33301 3.33398 4.08301 3.33398 4.99967V28.333L10.0007 21.6663H26.6673C27.584 21.6663 28.334 20.9163 28.334 19.9997V4.99967C28.334 4.08301 27.584 3.33301 26.6673 3.33301ZM35.0007 9.99967H31.6673V24.9997H10.0007V28.333C10.0007 29.2497 10.7507 29.9997 11.6673 29.9997H30.0007L36.6673 36.6663V11.6663C36.6673 10.7497 35.9173 9.99967 35.0007 9.99967Z",
    fill: "url(#paint0_linear_1433_23225)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1433_23225",
    x1: 4.00195,
    y1: 3.99902,
    x2: 36.002,
    y2: 35.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AB4F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44A6EF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1433_23225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusAreaSpokenInteractionIcon);
export default __webpack_public_path__ + "static/media/FocusAreaSpokenInteractionIcon.31434af4cb869876641f04470cd14862.svg";
export { ForwardRef as ReactComponent };